import React from 'react';

const LoadingPlaceholder = () => {
  return <p>Loading...</p>;
};

export default LoadingPlaceholder;
